import { allSteps, designSteps } from './stepper.machine';
import type { StepState } from './stepper.types';

import { DesignStepName, StepName } from '~/core/enums';

export const isADesignStep = (step: StepName) =>
  designSteps.includes(step as DesignStepName);

export const getStepState = <Step extends StepName>(
  step: Step,
  steps: StepName[] = allSteps
): StepState<Step> =>
  ((stepIndex) => ({
    current: step,
    next: steps[Math.min(Math.max(stepIndex, 0) + 1, steps.length - 1)],
  }))(steps.indexOf(step));

/**
 * @returns  1 | when `a` is greater than `b`
 * @returns  0 | when `a` equals `b`
 * @returns -1 | when `a` is less than `b`
 */
export const compareSteps = (a: StepName, b: StepName): -1 | 0 | 1 => {
  if (a === b) {
    return 0;
  }

  const prevSteps = allSteps.slice(0, allSteps.indexOf(b));

  return prevSteps.includes(a) ? -1 : 1;
};
